import ListStore from '@/store/core/ListStore';
import { action, computed, observable, override } from 'mobx';
import services from '@/api/services';
import { Taxpayers } from '@/store/types';
import { dateFormat, numGroup } from '@/utils/filters';
import { IIncomeReceipt } from '@/store/types';

const defaultFilters = {
  month: '',
  status: '',
  source: '',
};

export default class TaxpayersIncomeYearStore extends ListStore<{
  receipts: Array<IIncomeReceipt>;
  totalSumReceipt: number;
  count: number;
}> {
  @override
  filters = JSON.parse(JSON.stringify(defaultFilters));
  @observable overall = {
    totalSumReceipt: 0,
  };

  sortColumns: (keyof Taxpayers)[] = [];

  @computed get processedData() {
    if (!this.data?.receipts || !this.data?.receipts?.length) return;
    const items = this.data.receipts.map((item) => ({
      ...item,
      date: dateFormat(item.date, {
        format: 'DD.MM.YYYY',
        addHours: 0,
      }),
      sumReceipt: numGroup(item.sumReceipt),
    }));
    items.unshift({
      numReceipt: 'ИТОГО',
      customer: '',
      date: '',
      partner: '',
      status: '',
      sumReceipt: this.data.totalSumReceipt?.toLocaleString('ru-RU'),
      tin: '',
    });

    return { ...this.data, items };
  }

  @action.bound
  async fetch(id: string, params: { type: string; month: string }) {
    this.isFetching = true;
    try {
      const { data } = await services.selfEmployee.getTaxpayerIncome(
        id,
        params,
      );
      this.data = data;
      this.overall = { totalSumReceipt: data.totalSumReceipt };
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
